import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SEO = ({ title, description, canonicalPath = '' }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'es';

  useEffect(() => {
    // 1. Update Document Title
    const siteTitle = 'Laura Candela';
    if (title) {
      document.title = `${title} | ${siteTitle}`;
    } else {
      document.title = currentLang === 'es'
        ? `${siteTitle} | Actriz SAG-AFTRA, Locutora y Guionista`
        : `${siteTitle} | SAG-AFTRA Actress, Voice Talent & Screenwriter`;
    }

    // 2. Update HTML lang attribute
    document.documentElement.lang = currentLang;

    // 3. Update Meta Description
    const metaDesc = description || (currentLang === 'es'
      ? 'Sitio web oficial de Laura Candela: actriz bilingüe SAG-AFTRA, locutora internacional, actriz de doblaje y guionista para producciones de EE.UU. y Europa.'
      : 'Official website of Laura Candela: SAG-AFTRA bilingual actress, international voice talent, dubbing artist, and screenwriter working across US and European productions.');
    
    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement('meta');
      descTag.setAttribute('name', 'description');
      document.head.appendChild(descTag);
    }
    descTag.setAttribute('content', metaDesc);

    // 4. Update Open Graph Meta
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute('content', document.title);
    }

    let ogDescTag = document.querySelector('meta[property="og:description"]');
    if (ogDescTag) {
      ogDescTag.setAttribute('content', metaDesc);
    }

    // 5. Update Canonical link if specified
    if (canonicalPath) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute('href', `${window.location.origin}${canonicalPath}`);
      }
    }
  }, [title, description, canonicalPath, currentLang]);

  return null;
};

export default SEO;
